/**
 * Export stories
 * @author Ryan Gladstone
 */

function ExportStoriesController($scope, searchService) {
  // Copied from the storiesController and lightly modifed
  $scope.search = searchService.search({ name: 'storiesSearch', type: 'stories', refresh: false });
  $scope.filterSet = $scope.search.filterSet;

  $scope.$on('$destroy', () => {
    $scope.search.tearDown();
  });
}

const controllerArray = [
  '$scope',
  'searchService',
  ExportStoriesController
];

export default function (ngModule) {
  ngModule.controller('ExportStoriesController', controllerArray);
}
